import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MediaTypography from 'components/MediaTypography';
import useGetMenuMobile from 'modules/App/consts/menu';
import store from 'store';

import MenuItem from '../MenuItem';
import { MenuGrid, MenuListWrap } from './styled';

function MenuList() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const MenuMobile = useGetMenuMobile();
	const currentServiceId = store.services.current?.id;

	const handleNavigate = (href: string) => {
		navigate(href);
	};

	const greetingName = store.profile.first_name || store.profile.fullName;
	const greeting = greetingName
		? t('home.greeting', { name: greetingName })
		: t('home.greetingFallback');

	const filteredMenu = MenuMobile.filter((item) => {
		if (!currentServiceId || !item.services.includes(currentServiceId)) {
			return false;
		}

		if (item.excludeInMenuListServices?.includes(currentServiceId)) {
			return false;
		}

		if (item.text === 'home.main') {
			return false;
		}

		const userRoles = store.profile.roles.map((r) => r.name);

		if (item.excludeRoles?.some((role) => userRoles.includes(role))) {
			return false;
		}

		if (item.onlyFor?.length) {
			return item.onlyFor.some((role) => userRoles.includes(role));
		}

		return true;
	}).map((item) => {
		if (item.text === 'chat.main' && store.chat.unreadCount > 0) {
			return { ...item, badge: store.chat.unreadCount };
		}

		return item;
	});

	return (
		<MenuListWrap>
			<MediaTypography variant="h3">{greeting}</MediaTypography>
			<MenuGrid>
				{filteredMenu.map((item) => (
					<MenuItem onClick={handleNavigate} key={item.text} {...item} />
				))}
			</MenuGrid>
		</MenuListWrap>
	);
}

export default observer(MenuList);
